import './public-path';
import './styling/main.less';
import { createApp } from 'vue';

import { router } from './core/router';

import App from './App.vue';
import CoreConfig from '@/core/config';
import SharedConfig from '@/shared/config';
import '@/b2b/config';
import '@/b2c/config';
import '@/storecontext/config';

const app = createApp(App);

CoreConfig(app);
SharedConfig(app);

app.use(router).mount('#app');

export default app;
